"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayOfStrings = exports.isObject = exports.objectEntries = exports.objectKeys = exports.nullsToUndefined = exports.getInEnum = exports.enumKeys = exports.enumToHuman = exports.migrateEnum = exports.enumFromValueWithDefault = exports.enumFromNullableValue = exports.enumFromValue = exports.assertNonEmpty = exports.assertNotNil = exports.castArrayToNonEmpty = exports.mapNonEmptyArray = void 0;
const ramda_1 = require("ramda");
const lodash_isplainobject_1 = __importDefault(require("lodash.isplainobject"));
function mapNonEmptyArray(a, f) {
    return a.map(f);
}
exports.mapNonEmptyArray = mapNonEmptyArray;
function castArrayToNonEmpty(a) {
    if ((0, ramda_1.isEmpty)(a))
        throw new Error("Casting an empty array to NonEmptyArray!");
    return a;
}
exports.castArrayToNonEmpty = castArrayToNonEmpty;
function assertNotNil(x, message = "value is nullish") {
    if ((0, ramda_1.isNil)(x))
        throw new Error(message);
}
exports.assertNotNil = assertNotNil;
function assertNonEmpty(xs) {
    if ((0, ramda_1.isEmpty)(xs))
        throw new Error("Expected array to be non-empty");
}
exports.assertNonEmpty = assertNonEmpty;
const enumFromValue = (val, enumVar) => {
    const enumName = (0, exports.enumKeys)(enumVar).find((k) => enumVar[k] === val);
    if (!enumName)
        throw new Error(`Value "${val}" not found on string enum values ${JSON.stringify(enumVar)}`);
    return enumVar[enumName];
};
exports.enumFromValue = enumFromValue;
const enumFromNullableValue = (val, enumVar) => {
    if (val === null)
        return null;
    return (0, exports.enumFromValue)(val, enumVar);
};
exports.enumFromNullableValue = enumFromNullableValue;
const enumFromValueWithDefault = (val, enumVar, defaultVal) => {
    try {
        return (0, exports.enumFromValue)(val, enumVar);
    }
    catch {
        return defaultVal;
    }
};
exports.enumFromValueWithDefault = enumFromValueWithDefault;
function migrateEnum(val, migrationEnum, newEnum) {
    if ((0, ramda_1.isNil)(val))
        return undefined;
    const newEnumKeys = (0, exports.enumKeys)(newEnum);
    if (Object.values(migrationEnum).some((x) => !newEnumKeys.includes(x)))
        throw new Error("Not all values of migration enum mapped to keys of new enum");
    const enumKey = newEnumKeys.find((k) => newEnum[k] === val);
    if (enumKey)
        return newEnum[enumKey];
    const newEnumKey = migrationEnum[val];
    if (!newEnumKey) {
        throw new Error(`Value "${val}" not found on string enum values ${JSON.stringify(migrationEnum)}`);
    }
    return newEnum[newEnumKey];
}
exports.migrateEnum = migrateEnum;
const enumToHuman = (_enumVal, translations) => (key) => translations[key];
exports.enumToHuman = enumToHuman;
const { getOwnEnumerableNonNumericKeysES6 } = (() => {
    function isNonNumericKey(key) {
        return key !== String(parseFloat(key));
    }
    function getOwnEnumerableNonNumericKeysES6(obj) {
        return Object.getOwnPropertyNames(obj).filter((key) => obj.propertyIsEnumerable(key) && isNonNumericKey(key));
    }
    return { getOwnEnumerableNonNumericKeysES6 };
})();
const enumKeys = (enumVal) => getOwnEnumerableNonNumericKeysES6(enumVal);
exports.enumKeys = enumKeys;
const getInEnum = (val, enumVar) => {
    try {
        return (0, exports.enumFromValue)(val, enumVar);
    }
    catch (e) {
        return null;
    }
};
exports.getInEnum = getInEnum;
const nullsToUndefined = (obj) => {
    if ((0, ramda_1.isNil)(obj))
        return undefined;
    if ((0, lodash_isplainobject_1.default)(obj) || Array.isArray(obj)) {
        for (const key in obj) {
            obj[key] = (0, exports.nullsToUndefined)(obj[key]);
        }
    }
    return obj;
};
exports.nullsToUndefined = nullsToUndefined;
exports.objectKeys = Object.keys;
exports.objectEntries = Object.entries;
const isObject = (val) => val !== null && (0, lodash_isplainobject_1.default)(val);
exports.isObject = isObject;
const isArrayOfStrings = (arr) => (0, ramda_1.all)((item) => (0, ramda_1.is)(String, item), arr);
exports.isArrayOfStrings = isArrayOfStrings;
//# sourceMappingURL=ts-utils.js.map